import * as React from 'preact/compat'
import cn from 'classnames'
import type { JSX } from 'preact'
import Api from '../../../api'
import BackButton from '../BackButton'
import type { DialogComponentPropTypes } from '../AuthDialog'
import styles from '../../../../css/auth.pcss.json'
import formCss from '../../../../css/form.pcss.json'
import buttonsCss from '../../../../css/buttons.pcss.json'
import { loadStylesheet } from '../../../common/helpers'

interface StateTypes {
  isValid: boolean,
  isSending: boolean,
  error: string | null
}

export default class PageGetLogin extends React.Component<DialogComponentPropTypes, StateTypes> {

  state: StateTypes = {
    isValid: false,
    isSending: false,
    error: null
  }

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  setLogin: JSX.SubmitEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()

    const formData = new FormData(event.currentTarget)
    const authInfo = {
      ...this.props.authInfo,
      login: formData.get('login') as string
    }
    this.props.setAuthInfo(authInfo)
  }

  checkLogin: JSX.InputEventHandler<HTMLInputElement> = (event) => {
    const input = event.currentTarget
    const validity = input.validity

    if (validity.valid) {
      this.setState({
        isSending: true
      })
      Api.post({
        url: 'auth/check-login',
        body: { login: event.currentTarget.value }
      })
        .then(result => {
          this.setState({
            isSending: false,
            isValid: result.success,
            error: result.error ?? null
          })
        })
        .catch(() => {
          this.setState({
            isSending: false,
            error: 'Произошла непредвиденная ошибка.'
          })
        })
    } else {
      let message = input.validationMessage

      if (validity.patternMismatch) {
        message = 'Твой логин должен состоять только из букв латинского алфавита и(или) цифр'
      }
      if (validity.tooShort) {
        message = `Логин должен быть длиннее ${input.minLength} символов.`
      }
      if (validity.tooLong) {
        message = `Логин должен быть короче ${input.maxLength} символов.`
      }

      this.setState({
        isValid: false,
        error: message
      })
    }
  }

  toIndex = () => this.props.switchPage('index')

  render() {
    const { isValid, error } = this.state

    return <>
      <BackButton goBack={this.toIndex}/>
      <div className={styles['auth-header']}>
        <h1>Укажи желаемый логин</h1>
      </div>
      <form onSubmit={this.setLogin} style='display: flex; flex-direction: column; align-items: center;'>
        <input
          type="text"
          name="login"
          className={cn(formCss['input'], {
            [formCss['input--error']]: error,
          })}
          onInput={this.checkLogin}
          pattern="^[a-zA-Z0-9_-]+$"
          placeholder="Логин"
          minLength={3}
          maxLength={15}
          autocomplete="username"
          required
        />
        <p
          className={formCss['error-hint']}
          style={{ opacity: error ? 1 : 0, width: '100%' }}
        >{error || 'Нет ошибок'}</p>
        <button
          type="submit"
          disabled={!isValid}
          className={buttonsCss['primary']}
          style='min-width: 170px'
        >
          Сохранить
        </button>
      </form>
    </>
  }
}
